const coreScienceQuestions = [

{
  question: "Which step in the scientific method involves interpreting collected data to arrive at a decision?",
  options: ["Observation", "Analysis", "Hypothesis formulation", "Experimentation"],
  answer: "Analysis"
},
{
  question: "A scientist predicts that a plant will grow faster in sunlight than in shade. This statement is best described as:",
  options: ["Theory", "Conclusion", "Hypothesis", "Observation"],
  answer: "Hypothesis"
},
{
  question: "Which of the following is NOT a derived physical quantity?",
  options: ["Velocity", "Density", "Temperature", "Force"],
  answer: "Temperature"
},
{
  question: "The SI unit of electric current is:",
  options: ["Ampere", "Volt", "Ohm", "Coulomb"],
  answer: "Ampere"
},
{
  question: "Which instrument is most suitable for measuring the internal diameter of a test tube accurately?",
  options: ["Micrometer screw gauge", "Vernier calipers", "Meter rule", "Measuring cylinder"],
  answer: "Vernier calipers"
},
{
  question: "An error that occurs due to faulty calibration of an instrument is called:",
  options: ["Random error", "Systematic error", "Human error", "Parallax error"],
  answer: "Systematic error"
},
{
  question: "Which of the following best explains why repeated measurements are taken in experiments?",
  options: ["To eliminate all errors", "To increase precision and reliability", "To reduce cost", "To simplify calculations"],
  answer: "To increase precision and reliability"
},
{
  question: "A substance has a mass of 54 g and occupies a volume of 18 cm³. Its density is:",
  options: ["3.0 g/cm³", "2.5 g/cm³", "3.5 g/cm³", "2.0 g/cm³"],
  answer: "3.0 g/cm³"
},
{
  question: "Which of the following processes is NOT a characteristic of living organisms?",
  options: ["Respiration", "Crystallization", "Excretion", "Growth"],
  answer: "Crystallization"
},
{
  question: "Which level of classification comes immediately after class?",
  options: ["Order", "Family", "Genus", "Phylum"],
  answer: "Order"
},
{
  question: "Which scientist is credited with the binomial system of naming organisms?",
  options: ["Linnaeus", "Darwin", "Aristotle", "Mendel"],
  answer: "Linnaeus"
},
{
  question: "Which of the following best distinguishes living from non-living things?",
  options: ["Ability to move", "Ability to grow and reproduce", "Presence of mass", "Ability to occupy space"],
  answer: "Ability to grow and reproduce"
},
{
  question: "An atom is best described as:",
  options: ["The smallest unit of a compound", "A neutral particle made of protons, neutrons and electrons", "A charged particle in solution", "A combination of different elements"],
  answer: "A neutral particle made of protons, neutrons and electrons"
},
{
  question: "Which of the following represents a compound?",
  options: ["Air", "Sodium chloride", "Iron filings", "Sulphur"],
  answer: "Sodium chloride"
},
{
  question: "Which type of bonding involves transfer of electrons from one atom to another?",
  options: ["Covalent bonding", "Ionic bonding", "Metallic bonding", "Hydrogen bonding"],
  answer: "Ionic bonding"
},
{
  question: "The atomic number of an element represents the:",
  options: ["Number of neutrons", "Number of protons", "Sum of protons and neutrons", "Number of electrons and neutrons"],
  answer: "Number of protons"
},
{
  question: "Isotopes of an element differ in their:",
  options: ["Atomic number", "Chemical properties", "Number of neutrons", "Number of protons"],
  answer: "Number of neutrons"
},
{
  question: "The relative atomic mass of an element is defined based on:",
  options: ["Hydrogen-1", "Oxygen-16", "Carbon-12", "Nitrogen-14"],
  answer: "Carbon-12"
},
{
  question: "One mole of a substance contains:",
  options: ["6.02 × 10²³ particles", "6.02 × 10²² particles", "3.01 × 10²³ particles", "1.00 × 10²³ particles"],
  answer: "6.02 × 10²³ particles"
},
{
  question: "Which of the following best explains why ionic compounds conduct electricity in molten state?",
  options: ["Presence of free electrons", "Movement of ions", "High temperature", "Strong bonds"],
  answer: "Movement of ions"
},

{
  question: "Which cell organelle is directly responsible for protein synthesis?",
  options: ["Ribosome", "Mitochondrion", "Golgi apparatus", "Nucleus"],
  answer: "Ribosome"
},
{
  question: "Which structure controls the movement of substances into and out of the cell?",
  options: ["Cell membrane", "Cytoplasm", "Nucleus", "Cell wall"],
  answer: "Cell membrane"
},
{
  question: "Which of the following is present in plant cells but absent in animal cells?",
  options: ["Chloroplast", "Mitochondrion", "Ribosome", "Nucleus"],
  answer: "Chloroplast"
},
{
  question: "Osmosis is best defined as the movement of water molecules:",
  options: ["From higher to lower concentration through a semi-permeable membrane", "From lower to higher concentration without a membrane", "Across any membrane from low to high pressure", "From concentrated to dilute solution through diffusion"],
  answer: "From higher to lower concentration through a semi-permeable membrane"
},
{
  question: "Which process requires energy for the movement of substances across membranes?",
  options: ["Active transport", "Diffusion", "Osmosis", "Filtration"],
  answer: "Active transport"
},
{
  question: "A red blood cell placed in a hypertonic solution will:",
  options: ["Shrink", "Burst", "Remain unchanged", "Increase in size"],
  answer: "Shrink"
},
{
  question: "Which of the following best describes diffusion?",
  options: ["Movement of particles from high to low concentration", "Movement of water through a membrane", "Movement of particles against concentration gradient", "Movement due to pressure difference only"],
  answer: "Movement of particles from high to low concentration"
},
{
  question: "Which type of rock is formed from cooling of molten magma?",
  options: ["Igneous rock", "Sedimentary rock", "Metamorphic rock", "Organic rock"],
  answer: "Igneous rock"
},
{
  question: "Which process leads to the breakdown of rocks into smaller particles?",
  options: ["Weathering", "Erosion", "Deposition", "Sedimentation"],
  answer: "Weathering"
},
{
  question: "Metamorphic rocks are formed as a result of:",
  options: ["Heat and pressure", "Cooling of lava", "Deposition of sediments", "Biological activity"],
  answer: "Heat and pressure"
},
{
  question: "Which separation technique is most suitable for separating a mixture of sand and salt?",
  options: ["Dissolution, filtration and evaporation", "Filtration only", "Distillation", "Chromatography"],
  answer: "Dissolution, filtration and evaporation"
},
{
  question: "Which method is used to separate immiscible liquids?",
  options: ["Separating funnel", "Filtration", "Evaporation", "Chromatography"],
  answer: "Separating funnel"
},
{
  question: "Chromatography is mainly used to separate:",
  options: ["Components of a mixture based on solubility", "Liquids from solids", "Heavy metals", "Magnetic substances"],
  answer: "Components of a mixture based on solubility"
},
{
  question: "Which process is used to obtain pure water from seawater?",
  options: ["Distillation", "Filtration", "Sedimentation", "Decantation"],
  answer: "Distillation"
},
{
  question: "Which of the following is a physical change?",
  options: ["Melting of ice", "Burning of wood", "Rusting of iron", "Cooking of food"],
  answer: "Melting of ice"
},
{
  question: "Which state of matter has definite volume but no definite shape?",
  options: ["Liquid", "Solid", "Gas", "Plasma"],
  answer: "Liquid"
},
{
  question: "Which state of matter is highly compressible?",
  options: ["Gas", "Liquid", "Solid", "Crystal"],
  answer: "Gas"
},
{
  question: "The change from gas to liquid is called:",
  options: ["Condensation", "Evaporation", "Sublimation", "Melting"],
  answer: "Condensation"
},
{
  question: "Which of the following processes involves heat absorption?",
  options: ["Evaporation", "Condensation", "Freezing", "Solidification"],
  answer: "Evaporation"
},
{
  question: "Which factor does NOT affect the rate of evaporation?",
  options: ["Color of container", "Temperature", "Surface area", "Air movement"],
  answer: "Color of container"
},

{
  question: "Which enzyme is responsible for the breakdown of proteins into peptides in the stomach?",
  options: ["Pepsin", "Amylase", "Lipase", "Trypsin"],
  answer: "Pepsin"
},
{
  question: "Bile aids digestion primarily by:",
  options: ["Emulsifying fats to increase surface area", "Breaking down proteins into amino acids", "Neutralizing enzymes in the stomach", "Converting starch into glucose"],
  answer: "Emulsifying fats to increase surface area"
},
{
  question: "Which part of the alimentary canal is mainly responsible for absorption of digested food?",
  options: ["Ileum", "Stomach", "Duodenum", "Colon"],
  answer: "Ileum"
},
{
  question: "Which substance is absorbed into the lymphatic system instead of blood capillaries?",
  options: ["Fatty acids and glycerol", "Glucose", "Amino acids", "Mineral salts"],
  answer: "Fatty acids and glycerol"
},
{
  question: "Which process moves food along the alimentary canal?",
  options: ["Peristalsis", "Diffusion", "Osmosis", "Filtration"],
  answer: "Peristalsis"
},
{
  question: "Which gas is exchanged from blood to alveoli during respiration?",
  options: ["Carbon dioxide", "Oxygen", "Nitrogen", "Hydrogen"],
  answer: "Carbon dioxide"
},
{
  question: "The main function of haemoglobin is to:",
  options: ["Transport oxygen", "Fight infection", "Clot blood", "Regulate temperature"],
  answer: "Transport oxygen"
},
{
  question: "Which structure increases the surface area of the lungs for gas exchange?",
  options: ["Alveoli", "Bronchi", "Trachea", "Diaphragm"],
  answer: "Alveoli"
},
{
  question: "During inhalation, the diaphragm:",
  options: ["Contracts and flattens", "Relaxes and domes", "Moves upward", "Remains stationary"],
  answer: "Contracts and flattens"
},
{
  question: "Which blood vessel carries oxygenated blood from the lungs to the heart?",
  options: ["Pulmonary vein", "Pulmonary artery", "Aorta", "Vena cava"],
  answer: "Pulmonary vein"
},
{
  question: "Which chamber of the heart pumps blood to the lungs?",
  options: ["Right ventricle", "Left ventricle", "Right atrium", "Left atrium"],
  answer: "Right ventricle"
},
{
  question: "Which component of blood is mainly responsible for immunity?",
  options: ["White blood cells", "Red blood cells", "Platelets", "Plasma"],
  answer: "White blood cells"
},
{
  question: "Which blood vessels have the thickest muscular walls?",
  options: ["Arteries", "Veins", "Capillaries", "Venules"],
  answer: "Arteries"
},
{
  question: "Which organ is primarily responsible for removal of urea from the blood?",
  options: ["Kidney", "Liver", "Lung", "Skin"],
  answer: "Kidney"
},
{
  question: "Ultrafiltration in the kidney occurs in the:",
  options: ["Glomerulus", "Loop of Henle", "Ureter", "Bladder"],
  answer: "Glomerulus"
},
{
  question: "Which part of the nephron is mainly involved in selective reabsorption?",
  options: ["Proximal convoluted tubule", "Glomerulus", "Bowman's capsule", "Ureter"],
  answer: "Proximal convoluted tubule"
},
{
  question: "Which waste product is removed through the lungs?",
  options: ["Carbon dioxide", "Urea", "Sweat", "Salt"],
  answer: "Carbon dioxide"
},
{
  question: "Homeostasis refers to the:",
  options: ["Maintenance of stable internal environment", "Breakdown of food substances", "Movement of blood in vessels", "Production of energy"],
  answer: "Maintenance of stable internal environment"
},
{
  question: "Which organ regulates blood glucose levels?",
  options: ["Pancreas", "Liver", "Kidney", "Heart"],
  answer: "Pancreas"
},
{
  question: "Which hormone lowers blood glucose level?",
  options: ["Insulin", "Adrenaline", "Thyroxine", "Glucagon"],
  answer: "Insulin"
},

{
  question: "Which pigment is primarily responsible for trapping light energy during photosynthesis?",
  options: ["Chlorophyll a", "Chlorophyll b", "Carotene", "Xanthophyll"],
  answer: "Chlorophyll a"
},
{
  question: "Which factor directly affects the rate of photosynthesis by influencing enzyme activity?",
  options: ["Temperature", "Light intensity", "Carbon dioxide concentration", "Water availability"],
  answer: "Temperature"
},
{
  question: "The main product of photosynthesis that is transported in plants is:",
  options: ["Sucrose", "Glucose", "Starch", "Fructose"],
  answer: "Sucrose"
},
{
  question: "Which tissue is responsible for transporting water in plants?",
  options: ["Xylem", "Phloem", "Cambium", "Cortex"],
  answer: "Xylem"
},
{
  question: "Which tissue transports manufactured food in plants?",
  options: ["Phloem", "Xylem", "Epidermis", "Pith"],
  answer: "Phloem"
},
{
  question: "Transpiration mainly occurs through:",
  options: ["Stomata", "Lenticels", "Cuticle", "Root hairs"],
  answer: "Stomata"
},
{
  question: "Which factor increases the rate of transpiration?",
  options: ["High temperature", "High humidity", "Low wind speed", "Low light intensity"],
  answer: "High temperature"
},
{
  question: "Which process provides the driving force for water movement in plants?",
  options: ["Transpiration pull", "Root pressure", "Diffusion", "Osmosis"],
  answer: "Transpiration pull"
},
{
  question: "Which part of the plant is mainly responsible for absorption of water?",
  options: ["Root hairs", "Stem", "Leaves", "Flowers"],
  answer: "Root hairs"
},
{
  question: "Which mineral is essential for chlorophyll formation?",
  options: ["Magnesium", "Nitrogen", "Potassium", "Calcium"],
  answer: "Magnesium"
},
{
  question: "Which process converts glucose into starch in plants?",
  options: ["Polymerization", "Respiration", "Fermentation", "Oxidation"],
  answer: "Polymerization"
},
{
  question: "Which type of reproduction produces genetically identical offspring?",
  options: ["Asexual reproduction", "Sexual reproduction", "Pollination", "Fertilization"],
  answer: "Asexual reproduction"
},
{
  question: "Which structure in a flower produces pollen grains?",
  options: ["Anther", "Stigma", "Ovary", "Style"],
  answer: "Anther"
},
{
  question: "Which part of the flower receives pollen during pollination?",
  options: ["Stigma", "Ovary", "Anther", "Petal"],
  answer: "Stigma"
},
{
  question: "Which process involves the fusion of male and female gametes?",
  options: ["Fertilization", "Pollination", "Germination", "Reproduction"],
  answer: "Fertilization"
},
{
  question: "Which condition is necessary for seed germination?",
  options: ["Water, oxygen and suitable temperature", "Light, soil and air", "Carbon dioxide and sunlight", "Minerals and water only"],
  answer: "Water, oxygen and suitable temperature"
},
{
  question: "Phototropism is the response of plants to:",
  options: ["Light", "Gravity", "Water", "Touch"],
  answer: "Light"
},
{
  question: "Geotropism refers to the response of plants to:",
  options: ["Gravity", "Light", "Water", "Chemicals"],
  answer: "Gravity"
},
{
  question: "Which plant hormone promotes cell elongation in shoots?",
  options: ["Auxin", "Gibberellin", "Cytokinin", "Ethylene"],
  answer: "Auxin"
},
{
  question: "Which structure protects the developing seed in flowering plants?",
  options: ["Ovary", "Stigma", "Anther", "Sepal"],
  answer: "Ovary"
},

{
  question: "Work is said to be done when a force:",
  options: ["causes displacement in the direction of the force", "is applied irrespective of motion", "acts perpendicular to displacement", "is balanced by another force"],
  answer: "causes displacement in the direction of the force"
},
{
  question: "The SI unit of work is:",
  options: ["Joule", "Watt", "Newton", "Pascal"],
  answer: "Joule"
},
{
  question: "Which expression correctly represents work done?",
  options: ["Force × distance", "Mass × acceleration", "Force ÷ distance", "Distance ÷ force"],
  answer: "Force × distance"
},
{
  question: "Power is defined as the rate of:",
  options: ["doing work", "changing velocity", "energy storage", "force application"],
  answer: "doing work"
},
{
  question: "The SI unit of power is:",
  options: ["Watt", "Joule", "Newton", "Volt"],
  answer: "Watt"
},
{
  question: "Which of the following has the greatest kinetic energy?",
  options: ["Object with highest mass and velocity", "Object with lowest mass", "Object at rest", "Object with constant speed only"],
  answer: "Object with highest mass and velocity"
},
{
  question: "Potential energy depends mainly on:",
  options: ["Height and mass", "Speed only", "Temperature", "Volume"],
  answer: "Height and mass"
},
{
  question: "Which form of energy is stored in a stretched rubber band?",
  options: ["Elastic potential energy", "Kinetic energy", "Thermal energy", "Chemical energy"],
  answer: "Elastic potential energy"
},
{
  question: "Which energy transformation occurs in a hydroelectric power station?",
  options: ["Potential to electrical energy", "Chemical to thermal energy", "Electrical to mechanical energy", "Thermal to chemical energy"],
  answer: "Potential to electrical energy"
},
{
  question: "Efficiency of a machine is defined as:",
  options: ["Useful output ÷ total input", "Input ÷ output", "Output × input", "Input − output"],
  answer: "Useful output ÷ total input"
},
{
  question: "Which simple machine has a mechanical advantage equal to its velocity ratio?",
  options: ["Ideal machine", "Pulley system", "Lever", "Wheel and axle"],
  answer: "Ideal machine"
},
{
  question: "In a first-class lever, the fulcrum is located:",
  options: ["Between load and effort", "At one end", "Near the load", "Near the effort"],
  answer: "Between load and effort"
},
{
  question: "Heat transfer by direct contact of particles is called:",
  options: ["Conduction", "Convection", "Radiation", "Evaporation"],
  answer: "Conduction"
},
{
  question: "Which method of heat transfer occurs in liquids and gases?",
  options: ["Convection", "Conduction", "Radiation", "Reflection"],
  answer: "Convection"
},
{
  question: "Heat transfer through electromagnetic waves is called:",
  options: ["Radiation", "Conduction", "Convection", "Diffusion"],
  answer: "Radiation"
},
{
  question: "Which material is the best conductor of heat?",
  options: ["Copper", "Wood", "Plastic", "Rubber"],
  answer: "Copper"
},
{
  question: "Which factor does NOT affect heat transfer by conduction?",
  options: ["Color of material", "Temperature difference", "Thickness", "Nature of material"],
  answer: "Color of material"
},
{
  question: "Which surface is the best emitter of radiant heat?",
  options: ["Black dull surface", "Shiny polished surface", "White surface", "Smooth metallic surface"],
  answer: "Black dull surface"
},
{
  question: "Evaporation causes cooling because:",
  options: ["High energy particles escape", "Temperature increases", "Particles slow down", "Heat is added"],
  answer: "High energy particles escape"
},
{
  question: "Which factor increases the rate of evaporation?",
  options: ["Increased surface area", "High humidity", "Low temperature", "Still air"],
  answer: "Increased surface area"
},

{
  question: "Electric current is defined as the rate of flow of:",
  options: ["Electric charge", "Energy", "Potential difference", "Resistance"],
  answer: "Electric charge"
},
{
  question: "The SI unit of electric current is:",
  options: ["Ampere", "Volt", "Ohm", "Watt"],
  answer: "Ampere"
},
{
  question: "Potential difference is measured using a:",
  options: ["Voltmeter", "Ammeter", "Ohmmeter", "Galvanometer"],
  answer: "Voltmeter"
},
{
  question: "Which instrument is connected in series to measure current?",
  options: ["Ammeter", "Voltmeter", "Thermometer", "Barometer"],
  answer: "Ammeter"
},
{
  question: "Ohm’s law states that:",
  options: ["Current is directly proportional to voltage at constant temperature", "Voltage is inversely proportional to current", "Resistance varies with current", "Power is independent of voltage"],
  answer: "Current is directly proportional to voltage at constant temperature"
},
{
  question: "The unit of resistance is:",
  options: ["Ohm", "Volt", "Ampere", "Joule"],
  answer: "Ohm"
},
{
  question: "Which combination gives the correct relationship?",
  options: ["V = IR", "I = VR", "R = VI", "V = I/R"],
  answer: "V = IR"
},
{
  question: "In a series circuit, the current is:",
  options: ["The same at all points", "Different at each point", "Zero at some points", "Maximum at the source only"],
  answer: "The same at all points"
},
{
  question: "In a parallel circuit, the voltage across each branch is:",
  options: ["The same", "Different", "Zero", "Dependent on resistance only"],
  answer: "The same"
},
{
  question: "Which material is commonly used as a conductor?",
  options: ["Copper", "Rubber", "Plastic", "Glass"],
  answer: "Copper"
},
{
  question: "Which material is a good insulator?",
  options: ["Rubber", "Aluminium", "Copper", "Iron"],
  answer: "Rubber"
},
{
  question: "Electrical power is calculated using:",
  options: ["P = VI", "P = IR", "P = V/R", "P = I/V"],
  answer: "P = VI"
},
{
  question: "The unit of electrical energy is:",
  options: ["Joule", "Watt", "Volt", "Ohm"],
  answer: "Joule"
},
{
  question: "Which device converts electrical energy into heat energy?",
  options: ["Electric heater", "Generator", "Transformer", "Battery"],
  answer: "Electric heater"
},
{
  question: "A fuse is used in electrical circuits to:",
  options: ["Protect against excessive current", "Increase voltage", "Store energy", "Reduce resistance"],
  answer: "Protect against excessive current"
},
{
  question: "A magnet has two poles known as:",
  options: ["North and South poles", "Positive and negative poles", "East and West poles", "Upper and lower poles"],
  answer: "North and South poles"
},
{
  question: "Like poles of magnets:",
  options: ["Repel each other", "Attract each other", "Neutralize each other", "Produce current"],
  answer: "Repel each other"
},
{
  question: "Unlike poles of magnets:",
  options: ["Attract each other", "Repel each other", "Cancel each other", "Produce heat"],
  answer: "Attract each other"
},
{
  question: "The region around a magnet where magnetic force is felt is called:",
  options: ["Magnetic field", "Electric field", "Force field", "Current field"],
  answer: "Magnetic field"
},
{
  question: "An electromagnet is produced when current flows through a:",
  options: ["Coil of wire", "Metal rod", "Plastic tube", "Glass plate"],
  answer: "Coil of wire"
},

{
  question: "An ecosystem is best defined as:",
  options: ["A community of organisms interacting with their physical environment", "A group of similar organisms", "All plants in a given area", "A collection of animals only"],
  answer: "A community of organisms interacting with their physical environment"
},
{
  question: "Which of the following represents a biotic component of an ecosystem?",
  options: ["Bacteria", "Soil", "Water", "Temperature"],
  answer: "Bacteria"
},
{
  question: "Which of the following is an abiotic factor?",
  options: ["Light intensity", "Plants", "Animals", "Fungi"],
  answer: "Light intensity"
},
{
  question: "Producers in an ecosystem are organisms that:",
  options: ["Manufacture their own food", "Feed on other organisms", "Break down organic matter", "Store energy only"],
  answer: "Manufacture their own food"
},
{
  question: "Which group of organisms feeds directly on producers?",
  options: ["Primary consumers", "Secondary consumers", "Tertiary consumers", "Decomposers"],
  answer: "Primary consumers"
},
{
  question: "A food chain shows:",
  options: ["Flow of energy from one organism to another", "Relationship between species only", "Movement of water in soil", "Reproduction patterns"],
  answer: "Flow of energy from one organism to another"
},
{
  question: "Which of the following best describes a food web?",
  options: ["Interconnected food chains", "Single feeding relationship", "Energy loss only", "Plant-only interactions"],
  answer: "Interconnected food chains"
},
{
  question: "Energy transfer between trophic levels is inefficient mainly because:",
  options: ["Energy is lost as heat", "Organisms store all energy", "Energy increases at each level", "Energy is destroyed"],
  answer: "Energy is lost as heat"
},
{
  question: "Decomposers play a vital role by:",
  options: ["Recycling nutrients into the ecosystem", "Producing oxygen", "Consuming producers only", "Fixing nitrogen directly"],
  answer: "Recycling nutrients into the ecosystem"
},
{
  question: "Which of the following is a major greenhouse gas?",
  options: ["Carbon dioxide", "Oxygen", "Nitrogen", "Hydrogen"],
  answer: "Carbon dioxide"
},
{
  question: "Global warming is mainly caused by:",
  options: ["Increase in greenhouse gases", "Decrease in oxygen", "Increase in rainfall", "Decrease in sunlight"],
  answer: "Increase in greenhouse gases"
},
{
  question: "Which human activity contributes most to deforestation?",
  options: ["Logging", "Irrigation", "Fishing", "Mining"],
  answer: "Logging"
},
{
  question: "Eutrophication in water bodies is mainly caused by:",
  options: ["Excess nutrients", "Oil spills", "Plastic waste", "Thermal pollution"],
  answer: "Excess nutrients"
},
{
  question: "Which type of pollution affects the hearing ability of organisms?",
  options: ["Noise pollution", "Air pollution", "Water pollution", "Soil pollution"],
  answer: "Noise pollution"
},
{
  question: "Acid rain is formed mainly due to the presence of:",
  options: ["Sulphur dioxide and nitrogen oxides", "Carbon dioxide only", "Methane", "Oxygen"],
  answer: "Sulphur dioxide and nitrogen oxides"
},
{
  question: "Which conservation method involves protecting organisms in their natural habitat?",
  options: ["In-situ conservation", "Ex-situ conservation", "Artificial selection", "Domestication"],
  answer: "In-situ conservation"
},
{
  question: "National parks are examples of:",
  options: ["In-situ conservation", "Ex-situ conservation", "Artificial habitats", "Urban ecosystems"],
  answer: "In-situ conservation"
},
{
  question: "Which of the following is an example of ex-situ conservation?",
  options: ["Zoo", "Forest reserve", "National park", "Wildlife sanctuary"],
  answer: "Zoo"
},
{
  question: "Which practice helps to conserve soil fertility?",
  options: ["Crop rotation", "Deforestation", "Overgrazing", "Bush burning"],
  answer: "Crop rotation"
},
{
  question: "Which of the following best reduces environmental pollution?",
  options: ["Recycling waste materials", "Burning waste openly", "Dumping waste in rivers", "Using more fossil fuels"],
  answer: "Recycling waste materials"
},

{
  question: "The hydrological cycle involves the continuous movement of water between:",
  options: ["Atmosphere, land and water bodies", "Plants and animals only", "Soil and rocks only", "Air and sunlight only"],
  answer: "Atmosphere, land and water bodies"
},
{
  question: "Which process converts water vapour into liquid water in the atmosphere?",
  options: ["Condensation", "Evaporation", "Transpiration", "Sublimation"],
  answer: "Condensation"
},
{
  question: "Which process is responsible for the formation of clouds?",
  options: ["Condensation of water vapour", "Evaporation of water", "Freezing of water", "Melting of ice"],
  answer: "Condensation of water vapour"
},
{
  question: "Surface runoff occurs when:",
  options: ["Water flows over land into rivers", "Water evaporates into air", "Water freezes underground", "Water is absorbed by roots"],
  answer: "Water flows over land into rivers"
},
{
  question: "Which factor increases the rate of evaporation in the water cycle?",
  options: ["High temperature and wind speed", "High humidity and low temperature", "Low sunlight", "High pressure"],
  answer: "High temperature and wind speed"
},
{
  question: "Nitrogen fixation is the process of converting:",
  options: ["Atmospheric nitrogen into usable compounds", "Nitrates into nitrogen gas", "Ammonia into nitrates", "Proteins into amino acids"],
  answer: "Atmospheric nitrogen into usable compounds"
},
{
  question: "Which organisms are mainly responsible for nitrogen fixation?",
  options: ["Bacteria in root nodules", "Fungi in soil", "Animals", "Algae in water"],
  answer: "Bacteria in root nodules"
},
{
  question: "Which process converts ammonia into nitrates?",
  options: ["Nitrification", "Denitrification", "Ammonification", "Fixation"],
  answer: "Nitrification"
},
{
  question: "Denitrification results in the conversion of nitrates into:",
  options: ["Nitrogen gas", "Ammonia", "Proteins", "Oxygen"],
  answer: "Nitrogen gas"
},
{
  question: "Which process releases nitrogen back into the atmosphere?",
  options: ["Denitrification", "Nitrification", "Fixation", "Assimilation"],
  answer: "Denitrification"
},
{
  question: "Wind is caused mainly by:",
  options: ["Differences in air pressure", "Earth’s gravity", "Ocean currents", "Magnetic forces"],
  answer: "Differences in air pressure"
},
{
  question: "Air moves from regions of:",
  options: ["High pressure to low pressure", "Low pressure to high pressure", "Equal pressure", "Cold to hot regions only"],
  answer: "High pressure to low pressure"
},
{
  question: "Which instrument is used to measure atmospheric pressure?",
  options: ["Barometer", "Thermometer", "Hygrometer", "Anemometer"],
  answer: "Barometer"
},
{
  question: "Which instrument measures wind speed?",
  options: ["Anemometer", "Barometer", "Rain gauge", "Thermometer"],
  answer: "Anemometer"
},
{
  question: "Which instrument measures humidity?",
  options: ["Hygrometer", "Barometer", "Thermometer", "Anemometer"],
  answer: "Hygrometer"
},
{
  question: "Humidity refers to the amount of:",
  options: ["Water vapour in the air", "Oxygen in the air", "Carbon dioxide in the air", "Dust particles in the air"],
  answer: "Water vapour in the air"
},
{
  question: "Which factor most directly influences climate in coastal areas?",
  options: ["Large water bodies", "Soil type", "Vegetation only", "Altitude only"],
  answer: "Large water bodies"
},
{
  question: "Which of the following best explains land and sea breeze?",
  options: ["Differential heating of land and water", "Rotation of the earth", "Magnetic forces", "Ocean currents only"],
  answer: "Differential heating of land and water"
},
{
  question: "Which type of rainfall is caused by rising warm air?",
  options: ["Convectional rainfall", "Relief rainfall", "Cyclonic rainfall", "Frontal rainfall"],
  answer: "Convectional rainfall"
},
{
  question: "Relief rainfall occurs when air is forced to rise over:",
  options: ["Mountains", "Water bodies", "Deserts", "Forests"],
  answer: "Mountains"
},

{
  question: "A chemical reaction is best identified by the formation of:",
  options: ["New substances with different properties", "Mixtures of existing substances", "Physical changes only", "Temporary color changes only"],
  answer: "New substances with different properties"
},
{
  question: "Which type of reaction involves combination of two substances to form one product?",
  options: ["Synthesis reaction", "Decomposition reaction", "Displacement reaction", "Neutralization reaction"],
  answer: "Synthesis reaction"
},
{
  question: "Which reaction involves the breakdown of a compound into simpler substances?",
  options: ["Decomposition", "Synthesis", "Combustion", "Neutralization"],
  answer: "Decomposition"
},
{
  question: "Which type of reaction occurs when a more reactive metal displaces a less reactive one?",
  options: ["Displacement reaction", "Combination reaction", "Neutralization", "Decomposition"],
  answer: "Displacement reaction"
},
{
  question: "Which of the following is a characteristic of exothermic reactions?",
  options: ["Release of heat energy", "Absorption of heat", "Decrease in temperature", "No energy change"],
  answer: "Release of heat energy"
},
{
  question: "Which of the following is an endothermic process?",
  options: ["Photosynthesis", "Combustion", "Neutralization", "Respiration"],
  answer: "Photosynthesis"
},
{
  question: "An acid is defined as a substance that produces ______ in aqueous solution.",
  options: ["Hydrogen ions", "Hydroxide ions", "Electrons", "Neutrons"],
  answer: "Hydrogen ions"
},
{
  question: "A base is defined as a substance that produces ______ in aqueous solution.",
  options: ["Hydroxide ions", "Hydrogen ions", "Protons", "Electrons"],
  answer: "Hydroxide ions"
},
{
  question: "Which of the following is a strong acid?",
  options: ["Hydrochloric acid", "Ethanoic acid", "Carbonic acid", "Citric acid"],
  answer: "Hydrochloric acid"
},
{
  question: "Which of the following is a weak acid?",
  options: ["Ethanoic acid", "Sulphuric acid", "Nitric acid", "Hydrochloric acid"],
  answer: "Ethanoic acid"
},
{
  question: "Neutralization is the reaction between:",
  options: ["Acid and base to form salt and water", "Two acids", "Two bases", "Metal and oxygen"],
  answer: "Acid and base to form salt and water"
},
{
  question: "Which indicator turns blue in alkaline solution?",
  options: ["Litmus", "Methyl orange", "Phenolphthalein", "Universal indicator"],
  answer: "Litmus"
},
{
  question: "Which indicator is colorless in acidic solution and pink in alkaline solution?",
  options: ["Phenolphthalein", "Litmus", "Methyl orange", "Universal indicator"],
  answer: "Phenolphthalein"
},
{
  question: "The pH of a neutral solution is:",
  options: ["7", "0", "14", "1"],
  answer: "7"
},
{
  question: "Which of the following has a pH less than 7?",
  options: ["Acidic solution", "Alkaline solution", "Neutral solution", "Salt solution"],
  answer: "Acidic solution"
},
{
  question: "Salts are formed from the reaction between:",
  options: ["Acid and base", "Metal and oxygen", "Gas and liquid", "Two bases"],
  answer: "Acid and base"
},
{
  question: "Which salt is formed from hydrochloric acid?",
  options: ["Chloride", "Sulphate", "Nitrate", "Carbonate"],
  answer: "Chloride"
},
{
  question: "Which gas is produced when an acid reacts with a carbonate?",
  options: ["Carbon dioxide", "Oxygen", "Hydrogen", "Nitrogen"],
  answer: "Carbon dioxide"
},
{
  question: "Which gas is produced when an acid reacts with a metal?",
  options: ["Hydrogen", "Carbon dioxide", "Oxygen", "Nitrogen"],
  answer: "Hydrogen"
},
{
  question: "Which of the following best explains why acids conduct electricity in solution?",
  options: ["Presence of mobile ions", "Presence of molecules", "High temperature", "Strong bonds"],
  answer: "Presence of mobile ions"
},

{
  question: "A pathogen is best defined as:",
  options: ["A disease-causing organism", "A beneficial microorganism", "A chemical substance", "A body cell"],
  answer: "A disease-causing organism"
},
{
  question: "Which of the following is NOT a type of pathogen?",
  options: ["White blood cell", "Bacterium", "Virus", "Fungus"],
  answer: "White blood cell"
},
{
  question: "Which disease is caused by a virus?",
  options: ["Measles", "Tuberculosis", "Cholera", "Typhoid"],
  answer: "Measles"
},
{
  question: "Which disease is caused by bacteria?",
  options: ["Tuberculosis", "Malaria", "HIV/AIDS", "Influenza"],
  answer: "Tuberculosis"
},
{
  question: "Malaria is transmitted by:",
  options: ["Female Anopheles mosquito", "Housefly", "Tsetse fly", "Male mosquito"],
  answer: "Female Anopheles mosquito"
},
{
  question: "Which organism causes malaria?",
  options: ["Plasmodium", "Bacterium", "Virus", "Fungus"],
  answer: "Plasmodium"
},
{
  question: "Which disease affects the immune system directly?",
  options: ["HIV/AIDS", "Malaria", "Cholera", "Tuberculosis"],
  answer: "HIV/AIDS"
},
{
  question: "Which mode of transmission involves direct body contact?",
  options: ["Contact transmission", "Airborne transmission", "Vector transmission", "Waterborne transmission"],
  answer: "Contact transmission"
},
{
  question: "Which disease is spread through contaminated water?",
  options: ["Cholera", "Malaria", "Influenza", "Measles"],
  answer: "Cholera"
},
{
  question: "Which of the following is a vector?",
  options: ["Mosquito", "Water", "Air", "Soil"],
  answer: "Mosquito"
},
{
  question: "Immunity is defined as the ability of the body to:",
  options: ["Resist infection", "Digest food", "Produce energy", "Circulate blood"],
  answer: "Resist infection"
},
{
  question: "Which cells are mainly responsible for defense against pathogens?",
  options: ["White blood cells", "Red blood cells", "Platelets", "Plasma cells"],
  answer: "White blood cells"
},
{
  question: "Vaccination provides:",
  options: ["Artificial active immunity", "Natural immunity", "Passive immunity", "Temporary resistance"],
  answer: "Artificial active immunity"
},
{
  question: "Antibodies are produced by:",
  options: ["White blood cells", "Red blood cells", "Platelets", "Neurons"],
  answer: "White blood cells"
},
{
  question: "Which of the following helps to prevent disease transmission?",
  options: ["Proper sanitation", "Poor hygiene", "Overcrowding", "Contaminated food"],
  answer: "Proper sanitation"
},
{
  question: "Which of the following is a symptom of malaria?",
  options: ["Fever and chills", "Skin rash only", "Blindness", "Hair loss"],
  answer: "Fever and chills"
},
{
  question: "Which disease is associated with severe diarrhea and dehydration?",
  options: ["Cholera", "Malaria", "Measles", "Tuberculosis"],
  answer: "Cholera"
},
{
  question: "Which of the following is a method of controlling mosquito population?",
  options: ["Draining stagnant water", "Increasing waste", "Overcrowding areas", "Reducing sunlight"],
  answer: "Draining stagnant water"
},
{
  question: "Which type of immunity is obtained from mother to child?",
  options: ["Natural passive immunity", "Artificial active immunity", "Artificial passive immunity", "Acquired immunity"],
  answer: "Natural passive immunity"
},
{
  question: "Which of the following best explains the role of antibiotics?",
  options: ["They kill or inhibit bacteria", "They destroy viruses", "They boost immunity directly", "They prevent dehydration"],
  answer: "They kill or inhibit bacteria"
},

{
  question: "Which principle explains why ships made of steel float on water?",
  options: ["Average density is less than that of water", "Steel is lighter than water", "Water has no density", "Air inside ships has no mass"],
  answer: "Average density is less than that of water"
},
{
  question: "Which device converts mechanical energy into electrical energy?",
  options: ["Generator", "Motor", "Transformer", "Battery"],
  answer: "Generator"
},
{
  question: "Which device converts electrical energy into mechanical energy?",
  options: ["Electric motor", "Generator", "Solar panel", "Transformer"],
  answer: "Electric motor"
},
{
  question: "A transformer is used to:",
  options: ["Change voltage levels", "Store energy", "Produce current", "Measure resistance"],
  answer: "Change voltage levels"
},
{
  question: "Which energy source is renewable?",
  options: ["Solar energy", "Coal", "Petroleum", "Natural gas"],
  answer: "Solar energy"
},
{
  question: "Which energy source contributes most to environmental pollution?",
  options: ["Fossil fuels", "Wind energy", "Hydropower", "Solar energy"],
  answer: "Fossil fuels"
},
{
  question: "Which technology is used in long-distance communication?",
  options: ["Satellite", "Thermometer", "Barometer", "Hydrometer"],
  answer: "Satellite"
},
{
  question: "Which principle is used in the working of a refrigerator?",
  options: ["Evaporation absorbs heat", "Condensation absorbs heat", "Freezing releases heat", "Radiation cools objects"],
  answer: "Evaporation absorbs heat"
},
{
  question: "Which device is used to measure electrical resistance?",
  options: ["Ohmmeter", "Ammeter", "Voltmeter", "Thermometer"],
  answer: "Ohmmeter"
},
{
  question: "Which material is most suitable for making cooking pots?",
  options: ["Aluminium", "Plastic", "Wood", "Rubber"],
  answer: "Aluminium"
},
{
  question: "Which process is involved in water purification at treatment plants?",
  options: ["Filtration and chlorination", "Evaporation only", "Condensation only", "Magnetization"],
  answer: "Filtration and chlorination"
},
{
  question: "Which technology is used in medical imaging of bones?",
  options: ["X-ray", "Ultrasound", "Radio waves", "Infrared radiation"],
  answer: "X-ray"
},
{
  question: "Which wave type is used in microwave ovens?",
  options: ["Microwaves", "Radio waves", "X-rays", "Gamma rays"],
  answer: "Microwaves"
},
{
  question: "Which of the following is an application of electromagnets?",
  options: ["Electric bell", "Thermometer", "Barometer", "Hydrometer"],
  answer: "Electric bell"
},
{
  question: "Which device converts light energy directly into electrical energy?",
  options: ["Solar cell", "Generator", "Battery", "Transformer"],
  answer: "Solar cell"
},
{
  question: "Which factor determines the efficiency of a machine?",
  options: ["Energy losses", "Weight of machine", "Color of machine", "Temperature only"],
  answer: "Energy losses"
},
{
  question: "Which of the following reduces friction in machines?",
  options: ["Lubrication", "Heating", "Cooling", "Painting"],
  answer: "Lubrication"
},
{
  question: "Which of the following best explains the use of gears?",
  options: ["To change speed and direction of motion", "To store energy", "To reduce temperature", "To increase weight"],
  answer: "To change speed and direction of motion"
},
{
  question: "Which type of energy is stored in fuels?",
  options: ["Chemical energy", "Kinetic energy", "Thermal energy", "Electrical energy"],
  answer: "Chemical energy"
},
{
  question: "Which of the following best explains why metals are used in electrical wiring?",
  options: ["They have free electrons for conduction", "They are heavy", "They are hard", "They are shiny"],
  answer: "They have free electrons for conduction"
},

{
  question: "A student increases light intensity during an experiment on photosynthesis. Which factor must be controlled to ensure valid results?",
  options: ["Carbon dioxide concentration", "Leaf color", "Plant species", "Soil type"],
  answer: "Carbon dioxide concentration"
},
{
  question: "Which process explains the movement of mineral salts from soil into root hairs against concentration gradient?",
  options: ["Active transport", "Diffusion", "Osmosis", "Transpiration"],
  answer: "Active transport"
},
{
  question: "A decrease in atmospheric pressure will most likely result in:",
  options: ["Expansion of gases", "Compression of gases", "No change in volume", "Condensation of gases"],
  answer: "Expansion of gases"
},
{
  question: "Which factor most directly affects the rate of a chemical reaction?",
  options: ["Surface area of reactants", "Color of reactants", "Mass of container", "Shape of container"],
  answer: "Surface area of reactants"
},
{
  question: "Which condition will increase the resistance of a conductor?",
  options: ["Increase in temperature", "Decrease in length", "Increase in thickness", "Decrease in temperature"],
  answer: "Increase in temperature"
},
{
  question: "Which of the following explains why diffusion is faster in gases than in liquids?",
  options: ["Particles have higher kinetic energy", "Particles are larger", "Particles are stationary", "Particles have stronger bonds"],
  answer: "Particles have higher kinetic energy"
},
{
  question: "Which of the following processes removes carbon dioxide from the atmosphere?",
  options: ["Photosynthesis", "Respiration", "Combustion", "Decomposition"],
  answer: "Photosynthesis"
},
{
  question: "Which organ in humans is responsible for both excretion and osmoregulation?",
  options: ["Kidney", "Liver", "Lung", "Skin"],
  answer: "Kidney"
},
{
  question: "Which factor affects the rate of transpiration indirectly by influencing stomatal opening?",
  options: ["Light intensity", "Soil type", "Mineral content", "Plant age"],
  answer: "Light intensity"
},
{
  question: "Which process is responsible for the release of energy stored in food?",
  options: ["Respiration", "Photosynthesis", "Digestion", "Excretion"],
  answer: "Respiration"
},
{
  question: "Which of the following is a non-renewable source of energy?",
  options: ["Coal", "Wind", "Solar", "Hydropower"],
  answer: "Coal"
},
{
  question: "Which type of circuit will continue to function even if one component fails?",
  options: ["Parallel circuit", "Series circuit", "Closed circuit", "Open circuit"],
  answer: "Parallel circuit"
},
{
  question: "Which of the following explains why metals expand when heated?",
  options: ["Increase in kinetic energy of particles", "Decrease in particle size", "Loss of electrons", "Formation of new bonds"],
  answer: "Increase in kinetic energy of particles"
},
{
  question: "Which factor determines the strength of an electromagnet?",
  options: ["Number of coil turns", "Color of wire", "Length of wire only", "Temperature of wire"],
  answer: "Number of coil turns"
},
{
  question: "Which process converts nitrates into proteins in plants?",
  options: ["Assimilation", "Fixation", "Denitrification", "Nitrification"],
  answer: "Assimilation"
},
{
  question: "Which of the following explains why oil floats on water?",
  options: ["Lower density than water", "Higher viscosity", "Higher temperature", "Chemical reaction"],
  answer: "Lower density than water"
},
{
  question: "Which of the following best explains the greenhouse effect?",
  options: ["Trapping of heat by gases in the atmosphere", "Reflection of sunlight by clouds", "Absorption of oxygen by plants", "Cooling of the earth’s surface"],
  answer: "Trapping of heat by gases in the atmosphere"
},
{
  question: "Which process is involved when a solid changes directly into gas?",
  options: ["Sublimation", "Condensation", "Melting", "Evaporation"],
  answer: "Sublimation"
},
{
  question: "Which factor determines the pressure exerted by a liquid?",
  options: ["Depth and density", "Color and temperature", "Volume only", "Shape of container"],
  answer: "Depth and density"
},
{
  question: "Which of the following best explains why vaccines are effective?",
  options: ["They stimulate antibody production", "They kill all pathogens instantly", "They increase body temperature", "They prevent exposure to pathogens"],
  answer: "They stimulate antibody production"
},

{
  question: "A plant is placed in the dark for 48 hours and then exposed to light. Why is this step important before testing for starch?",
  options: ["To remove previously stored starch", "To increase chlorophyll content", "To stop respiration completely", "To increase water uptake"],
  answer: "To remove previously stored starch"
},
{
  question: "Which condition would most likely reduce the rate of enzyme activity in digestion?",
  options: ["Extreme pH", "Moderate temperature", "Adequate substrate", "Presence of cofactors"],
  answer: "Extreme pH"
},
{
  question: "Which factor determines whether a reaction is exothermic or endothermic?",
  options: ["Energy change during reaction", "Mass of reactants", "Volume of products", "Color of substances"],
  answer: "Energy change during reaction"
},
{
  question: "Which of the following explains why increasing pressure increases the rate of reaction between gases?",
  options: ["Particles collide more frequently", "Particles lose energy", "Particles become larger", "Particles slow down"],
  answer: "Particles collide more frequently"
},
{
  question: "Which factor affects both resistance in a wire and heat produced in it?",
  options: ["Length of wire", "Color of wire", "Shape of battery", "Position of switch"],
  answer: "Length of wire"
},
{
  question: "Which biological process depends directly on diffusion?",
  options: ["Gas exchange in alveoli", "Blood circulation", "Digestion in stomach", "Urine formation"],
  answer: "Gas exchange in alveoli"
},
{
  question: "Which of the following best explains why capillaries have thin walls?",
  options: ["To allow rapid exchange of substances", "To increase blood pressure", "To reduce blood flow", "To prevent diffusion"],
  answer: "To allow rapid exchange of substances"
},
{
  question: "Which factor limits population growth in an ecosystem?",
  options: ["Availability of resources", "Color of organisms", "Size of habitat only", "Presence of sunlight only"],
  answer: "Availability of resources"
},
{
  question: "Which of the following best explains bioaccumulation?",
  options: ["Increase of toxins along food chains", "Reduction of energy in ecosystems", "Movement of nutrients in soil", "Growth of organisms"],
  answer: "Increase of toxins along food chains"
},
{
  question: "Which process converts kinetic energy into electrical energy in power generation?",
  options: ["Electromagnetic induction", "Conduction", "Radiation", "Convection"],
  answer: "Electromagnetic induction"
},
{
  question: "Which of the following explains why metals are good thermal conductors?",
  options: ["Free movement of electrons", "Strong bonds only", "Large particle size", "High density"],
  answer: "Free movement of electrons"
},
{
  question: "Which factor determines the boiling point of a liquid?",
  options: ["Intermolecular forces", "Color of liquid", "Shape of container", "Volume only"],
  answer: "Intermolecular forces"
},
{
  question: "Which of the following best explains the function of valves in veins?",
  options: ["Prevent backflow of blood", "Increase blood pressure", "Filter blood", "Pump blood"],
  answer: "Prevent backflow of blood"
},
{
  question: "Which factor affects the rate of transpiration by changing the diffusion gradient?",
  options: ["Humidity", "Soil type", "Root length", "Leaf color"],
  answer: "Humidity"
},
{
  question: "Which of the following best explains why nitrogen is essential for plant growth?",
  options: ["It is used to synthesize proteins", "It increases water absorption", "It improves soil structure", "It provides energy"],
  answer: "It is used to synthesize proteins"
},
{
  question: "Which of the following processes increases atmospheric carbon dioxide?",
  options: ["Combustion", "Photosynthesis", "Condensation", "Nitrification"],
  answer: "Combustion"
},
{
  question: "Which factor determines the intensity of sound?",
  options: ["Amplitude of vibration", "Frequency of vibration", "Speed of wave", "Wavelength only"],
  answer: "Amplitude of vibration"
},
{
  question: "Which of the following explains why pressure increases with depth in a liquid?",
  options: ["Weight of liquid above increases", "Temperature increases", "Volume decreases", "Density decreases"],
  answer: "Weight of liquid above increases"
},
{
  question: "Which of the following best explains how antibodies function?",
  options: ["Bind to specific antigens", "Destroy all cells", "Increase body temperature", "Produce oxygen"],
  answer: "Bind to specific antigens"
},
{
  question: "Which of the following explains why renewable energy sources are preferred?",
  options: ["They are sustainable and less polluting", "They produce more heat", "They are always cheaper", "They require no technology"],
  answer: "They are sustainable and less polluting"
},

{
  question: "A plant exposed to high light intensity but low carbon dioxide will show reduced photosynthesis because:",
  options: ["Carbon dioxide becomes the limiting factor", "Light intensity stops enzyme activity", "Oxygen concentration increases", "Temperature becomes irrelevant"],
  answer: "Carbon dioxide becomes the limiting factor"
},
{
  question: "Which condition will most likely denature an enzyme permanently?",
  options: ["Very high temperature", "Low substrate concentration", "Moderate pH", "Presence of oxygen"],
  answer: "Very high temperature"
},
{
  question: "Which of the following explains why increasing concentration increases reaction rate?",
  options: ["More frequent collisions between particles", "Decrease in particle energy", "Increase in activation energy", "Reduction in surface area"],
  answer: "More frequent collisions between particles"
},
{
  question: "Which factor affects both electrical resistance and heat generation in a conductor?",
  options: ["Temperature", "Color", "Volume", "Position"],
  answer: "Temperature"
},
{
  question: "Which process explains the movement of water from soil into plant roots?",
  options: ["Osmosis", "Diffusion", "Active transport", "Transpiration"],
  answer: "Osmosis"
},
{
  question: "Which of the following explains why veins have wider lumen than arteries?",
  options: ["Lower pressure of blood flow", "Higher oxygen content", "Thicker walls", "Faster blood flow"],
  answer: "Lower pressure of blood flow"
},
{
  question: "Which factor most directly affects biodiversity in an ecosystem?",
  options: ["Habitat stability", "Color of organisms", "Temperature only", "Size of animals"],
  answer: "Habitat stability"
},
{
  question: "Which of the following best explains energy loss in food chains?",
  options: ["Energy lost as heat during metabolism", "Energy is destroyed", "Energy increases upward", "Energy is stored completely"],
  answer: "Energy lost as heat during metabolism"
},
{
  question: "Which process converts electrical energy into heat in appliances?",
  options: ["Resistance heating", "Induction", "Radiation", "Convection"],
  answer: "Resistance heating"
},
{
  question: "Which of the following explains why pressure in gases increases with temperature?",
  options: ["Particles move faster and collide more frequently", "Particles become heavier", "Particles lose energy", "Particles shrink"],
  answer: "Particles move faster and collide more frequently"
},
{
  question: "Which of the following best explains why acids react with metals?",
  options: ["Presence of hydrogen ions", "Presence of oxygen", "High temperature", "Low density"],
  answer: "Presence of hydrogen ions"
},
{
  question: "Which factor determines the rate of diffusion in liquids?",
  options: ["Temperature and concentration gradient", "Color and shape", "Volume only", "Mass only"],
  answer: "Temperature and concentration gradient"
},
{
  question: "Which of the following explains the function of stomata in plants?",
  options: ["Regulate gas exchange and water loss", "Absorb nutrients", "Produce food directly", "Store water"],
  answer: "Regulate gas exchange and water loss"
},
{
  question: "Which of the following best explains the role of chlorophyll?",
  options: ["Absorbs light energy for photosynthesis", "Produces carbon dioxide", "Stores oxygen", "Breaks down glucose"],
  answer: "Absorbs light energy for photosynthesis"
},
{
  question: "Which factor determines the strength of a magnetic field in an electromagnet?",
  options: ["Current and number of turns", "Color of core", "Length of wire only", "Temperature only"],
  answer: "Current and number of turns"
},
{
  question: "Which of the following explains why metals are malleable?",
  options: ["Layers of atoms can slide over each other", "Strong covalent bonds", "Rigid structure", "Fixed positions"],
  answer: "Layers of atoms can slide over each other"
},
{
  question: "Which of the following processes removes nitrogen from the soil?",
  options: ["Denitrification", "Nitrification", "Fixation", "Assimilation"],
  answer: "Denitrification"
},
{
  question: "Which factor determines the boiling point of a substance?",
  options: ["Strength of intermolecular forces", "Color of substance", "Shape of container", "Volume of liquid"],
  answer: "Strength of intermolecular forces"
},
{
  question: "Which of the following best explains how vaccines provide immunity?",
  options: ["Stimulate production of memory cells", "Destroy all pathogens instantly", "Increase body temperature", "Prevent infection completely"],
  answer: "Stimulate production of memory cells"
},
{
  question: "Which of the following explains why renewable energy is sustainable?",
  options: ["It can be replenished naturally", "It produces more energy", "It is always cheap", "It requires no maintenance"],
  answer: "It can be replenished naturally"
},

{
  question: "The diagram shows a plant cell. Which part is responsible for photosynthesis?",
  image: "/images/coresci1.png",
  options: ["Chloroplast", "Nucleus", "Cell wall", "Vacuole"],
  answer: "Chloroplast"
},

{
  question: "The diagram shows an animal cell. Which structure controls all activities of the cell?",
  image: "/images/coresci2.png",
  options: ["Nucleus", "Mitochondrion", "Cytoplasm", "Membrane"],
  answer: "Nucleus"
},

{
  question: "The diagram shows a microscope. Which part is used to focus the image?",
  image: "/images/coresci3.png",
  options: ["Adjustment knob", "Stage", "Lens", "Mirror"],
  answer: "Adjustment knob"
},

{
  question: "The diagram shows a measuring cylinder. What is the correct reading?",
  image: "/images/coresci4.png",
  options: ["Meniscus reading", "Top reading", "Bottom reading", "Side reading"],
  answer: "Meniscus reading"
},

{
  question: "The diagram shows particles in a solid, liquid and gas. Which state has the most spacing?",
  image: "/images/coresci5.png",
  options: ["Gas", "Liquid", "Solid", "All equal"],
  answer: "Gas"
},

{
  question: "The diagram shows an atom. Which part carries a positive charge?",
  image: "/images/coresci6.png",
  options: ["Proton", "Electron", "Neutron", "Shell"],
  answer: "Proton"
},

{
  question: "The diagram shows ionic bonding. What happens during this process?",
  image: "/images/coresci7.png",
  options: ["Transfer of electrons", "Sharing of electrons", "Loss of atoms", "Gain of neutrons"],
  answer: "Transfer of electrons"
},

{
  question: "The diagram shows covalent bonding. What occurs?",
  image: "/images/coresci8.png",
  options: ["Sharing of electrons", "Transfer of electrons", "Loss of protons", "Gain of neutrons"],
  answer: "Sharing of electrons"
},

{
  question: "The diagram shows types of rocks. Which rock is formed by cooling magma?",
  image: "/images/coresci9.png",
  options: ["Igneous", "Sedimentary", "Metamorphic", "Organic"],
  answer: "Igneous"
},

{
  question: "The diagram shows weathering of rocks. What type is caused by chemical reactions?",
  image: "/images/coresci10.png",
  options: ["Chemical weathering", "Physical weathering", "Biological weathering", "Mechanical weathering"],
  answer: "Chemical weathering"
},

{
  question: "The diagram shows the human skeleton. Which part protects the brain?",
  image: "/images/coresci11.png",
  options: ["Skull", "Rib cage", "Spine", "Pelvis"],
  answer: "Skull"
},

{
  question: "The diagram shows the skeleton. Which part supports body weight?",
  image: "/images/coresci12.png",
  options: ["Vertebral column", "Skull", "Ribs", "Arms"],
  answer: "Vertebral column"
},

{
  question: "The diagram shows types of joints. Which joint allows movement in all directions?",
  image: "/images/coresci13.png",
  options: ["Ball and socket", "Hinge", "Pivot", "Fixed"],
  answer: "Ball and socket"
},

{
  question: "The diagram shows a tooth. Which part contains nerves and blood vessels?",
  image: "/images/coresci14.png",
  options: ["Pulp cavity", "Enamel", "Dentine", "Crown"],
  answer: "Pulp cavity"
},

{
  question: "The diagram shows types of teeth. Which is used for tearing food?",
  image: "/images/coresci15.png",
  options: ["Canine", "Incisor", "Molar", "Premolar"],
  answer: "Canine"
},

{
  question: "The diagram shows the digestive system. Where does digestion begin?",
  image: "/images/coresci16.png",
  options: ["Mouth", "Stomach", "Intestine", "Liver"],
  answer: "Mouth"
},

{
  question: "The diagram shows digestive organs. Which organ produces bile?",
  image: "/images/coresci17.png",
  options: ["Liver", "Pancreas", "Stomach", "Kidney"],
  answer: "Liver"
},

{
  question: "The diagram shows the respiratory system. Which organ is responsible for gas exchange?",
  image: "/images/coresci18.png",
  options: ["Lungs", "Trachea", "Ribs", "Nose"],
  answer: "Lungs"
},

{
  question: "The diagram shows breathing mechanism. What happens during inhalation?",
  image: "/images/coresci19.png",
  options: ["Diaphragm contracts", "Diaphragm relaxes", "Ribs move inward", "Air moves out"],
  answer: "Diaphragm contracts"
},

{
  question: "The diagram shows alveoli. What is their function?",
  image: "/images/coresci20.png",
  options: ["Gas exchange", "Digestion", "Circulation", "Excretion"],
  answer: "Gas exchange"
},

{
  question: "The diagram shows a simple electric circuit. What happens when the switch is closed?",
  image: "/images/coresci21.png",
  options: ["Current flows", "Circuit breaks", "Bulb goes off", "No change"],
  answer: "Current flows"
},

{
  question: "The diagram shows a circuit with a bulb. What energy change occurs?",
  image: "/images/coresci22.png",
  options: ["Electrical to light", "Chemical to heat", "Light to sound", "Heat to electrical"],
  answer: "Electrical to light"
},

{
  question: "The diagram shows circuit symbols. Which symbol represents a resistor?",
  image: "/images/coresci23.png",
  options: ["Zigzag line", "Circle", "Straight line", "Triangle"],
  answer: "Zigzag line"
},

{
  question: "The diagram shows series circuit. What happens if one bulb is removed?",
  image: "/images/coresci24.png",
  options: ["All go off", "Others stay on", "Brightness increases", "Nothing happens"],
  answer: "All go off"
},

{
  question: "The diagram shows parallel circuit. What happens if one bulb is removed?",
  image: "/images/coresci25.png",
  options: ["Others stay on", "All go off", "Circuit breaks", "Voltage drops to zero"],
  answer: "Others stay on"
},

{
  question: "The diagram shows a battery. What does it supply?",
  image: "/images/coresci26.png",
  options: ["Energy", "Light", "Heat", "Sound"],
  answer: "Energy"
},

{
  question: "The diagram shows an ammeter connected in a circuit. How is it connected?",
  image: "/images/coresci27.png",
  options: ["In series", "In parallel", "Across component", "Separately"],
  answer: "In series"
},

{
  question: "The diagram shows a voltmeter. How is it connected?",
  image: "/images/coresci28.png",
  options: ["In parallel", "In series", "Outside circuit", "Across battery only"],
  answer: "In parallel"
},

{
  question: "The diagram shows household wiring. What is the function of a fuse?",
  image: "/images/coresci29.png",
  options: ["Protect circuit", "Increase voltage", "Store energy", "Generate current"],
  answer: "Protect circuit"
},

{
  question: "The diagram shows solar panel. What type of energy is converted?",
  image: "/images/coresci30.png",
  options: ["Solar to electrical", "Electrical to heat", "Heat to light", "Chemical to electrical"],
  answer: "Solar to electrical"
}

];

export default coreScienceQuestions;
